/**
 * Service Supabase - Configuration et exports
 * Pour l'authentification et le stockage de fichiers
 */

import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_SUPABASE_KEY

if (!supabaseUrl || !supabaseKey) {
  console.error('Variables d\'environnement Supabase manquantes')
}

/**
 * Client Supabase configuré
 */
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'pdm-supabase-auth',
  },
})

/**
 * Service de stockage Supabase
 */
export const storage = {
  /**
   * Upload d'une image
   */
  async uploadImage(bucket, path, file) {
    const { data, error } = await supabase.storage
      .from(bucket)
      .upload(path, file, {
        cacheControl: '3600',
        upsert: true,
      })
    
    if (error) throw error
    return data
  },
  
  /**
   * Récupère l'URL publique d'un fichier
   */
  getPublicUrl(bucket, path) {
    const { data } = supabase.storage.from(bucket).getPublicUrl(path)
    return data.publicUrl
  },
  
  /**
   * Supprime un fichier
   */
  async removeFile(bucket, path) {
    const { error } = await supabase.storage.from(bucket).remove([path])
    if (error) throw error
  },
  
  /**
   * Liste les fichiers d'un bucket
   */
  async listFiles(bucket, path = '') {
    const { data, error } = await supabase.storage.from(bucket).list(path)
    if (error) throw error
    return data
  },
}

/**
 * Service d'authentification Supabase
 */
export const auth = supabase.auth
